import { safeFetch } from "../utils/safeFetch";
import { removeCachedData } from "../utils/offlineDb";

const ROOMS_CACHE_KEY = 'allRooms';

const invalidateRoomsCache = async () => {
    try {
        await removeCachedData(ROOMS_CACHE_KEY);
    } catch (error) {
        console.warn("Impossibile invalidare la cache delle sale:", error);
    }
};

export const getAllStanze = async (token, tenant, options = {}) => {
    const noCache = Boolean(options?.noCache);
    const url = noCache ? `/api/rooms?ts=${Date.now()}` : `/api/rooms`;
    const response = await safeFetch(url, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant
        }
    }, noCache ? null : ROOMS_CACHE_KEY);

    if (!response.ok) {
        if (response.status === 0) {
            throw new Error("Impossibile connettersi al server o recuperare dati offline.");
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    }

    return await response.json();
};

export const getStanzaById = async ( roomId, token, tenant) => {
    const response = await safeFetch(`/api/rooms/${roomId}`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenant
        }
    });

    if (!response.ok) {
        if (response.status === 0) {
            throw new Error("Impossibile connettersi al server o recuperare dati offline.");
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    }

    return await response.json();
};

export const creaStanza = async (stanza, token, tenant) => {
    const response = await safeFetch(`/api/rooms`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(stanza),
    });

    if (!response.ok) {
        if (response.status === 0) {
            throw new Error("Impossibile connettersi al server");
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    }

    const data = await response.json();
    await invalidateRoomsCache();
    return data;
};

export const aggiornaStanza = async (roomId, updatedData, token, tenant) => {
    const response = await safeFetch(`/api/rooms/${roomId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(updatedData),
    });

    if (!response.ok) {
        if (response.status === 0) {
            throw new Error("Impossibile connettersi al server");
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    }

    const data = await response.json();
    await invalidateRoomsCache();
    return data;
};

export const eliminaStanza = async (roomId, token, tenant) => {
    const response = await safeFetch(`/api/rooms/${roomId}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
    });

    if (!response.ok) {
        if (response.status === 0) {
            throw new Error("Impossibile connettersi al server");
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    }

    await invalidateRoomsCache();
};
